module.exports = __webpack_public_path__ + "media/images/avatar/demi-6d44a2080e64e1067c26cea2578d8f49.png";